<p-dialog [(visible)]="visible" appendTo="body" [modal]="!deviceManager.isMobile" [closable]="true" [showHeader]="true" (onHide)="onHide()"
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          styleClass="select-stock-image-dialog">
    <p-header>Select Image</p-header>
    <p-dataView #dv [value]="stockImages" layout="grid">
        <ng-template pTemplate="grid" let-images>
            <div *ngFor="let image of images" class="stock-image" [class.selected]="selectedImage?.Id === image.Id" (click)="selectedImage = image">
                <div class="name">{{image.Name}}</div>
                <div class="image"><img [src]="image.Url" [alt]="image.Name" /></div>
            </div>
        </ng-template>
    </p-dataView>
    <ng-template pTemplate="footer">
        <button pButton type="button" class="ok-button" label="Use Selected Image" icon="pi pi-check" (click)="onOk()" [disabled]="selectedImage === undefined"></button>
    </ng-template>

    <mycampapp-waiting-indicator *ngIf="busy" [@fadeInOut] ></mycampapp-waiting-indicator>
</p-dialog>

